'use strict';

var customEncodeForHTML = function(value) {
    if (typeof value !== 'string') {
        return value;
    }

    // Decode HTML entities to prevent double encoding
    value = value.replace(/&amp;/g, '&')
                 .replace(/&lt;/g, '<')
                 .replace(/&gt;/g, '>')
                 .replace(/&quot;/g, '"')
                 .replace(/&#39;/g, "'");

    // Replace special characters with their HTML entities
    return value.replace(/[&<>"']/g, function(match) {
        switch (match) {
            case '&':
                return '&amp;';
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            case '"':
                return '&quot;';
            case "'":
                return '&#39;';
            default:
                return match;
        }
    });
}

var customDecodingForInput = function (value) {
    if (typeof value !== 'string') {
        return value;
    }

    // Decode HTML entities to prevent double encoding
    value = value.replace(/&amp;/g, '&')
                 .replace(/&lt;/g, '<')
                 .replace(/&gt;/g, '>')
                 .replace(/&quot;/g, '"')
                 .replace(/&#39;/g, "'");
    return value;
}

module.exports = {
    customEncodeForHTML: customEncodeForHTML,
    customDecodingForInput: customDecodingForInput
};